exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header{padding-bottom:8px;margin-bottom:24px;border-bottom:1px solid gray}.header h1{margin-bottom:0}", ""]);

// exports
